import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, EnvelopeSimple, ChatCircle, Trash } from "@phosphor-icons/react";
import { api } from "../../lib/api";

const AUDIENCE_LABEL = {
  all_applied: "All applied",
  all_approved: "All approved",
  guests: "Guests only",
  sponsor_team: "Sponsor team",
  sponsor_request: "Sponsor requests",
  all_subscribers: "Newsletter subscribers",
};

const AdminBroadcasts = () => {
  const [list, setList] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const load = () => api.get("/admin/broadcasts").then(({ data }) => { setList(data); setLoaded(true); });
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this broadcast log?")) return;
    await api.delete(`/admin/broadcasts/${id}`);
    load();
  };

  return (
    <div data-testid="admin-broadcasts-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="term-label">/ broadcasts</div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl mt-2">Broadcasts.</h1>
          <p className="text-white/60 mt-2 text-sm font-mono-tech">Mass email + SMS to RSVPs. Pre-event reminders & urgent updates.</p>
        </div>
        <Link to="/admin/broadcasts/new" className="btn-neon" data-testid="new-broadcast-btn">
          <Plus size={14} weight="bold" /> New broadcast
        </Link>
      </div>

      <div className="hard-border bg-cyber-surface">
        <div className="grid grid-cols-12 gap-2 px-5 py-3 border-b border-cyber-line bg-cyber-elevated font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/60">
          <div className="col-span-1">Ch</div>
          <div className="col-span-4">Name / subject</div>
          <div className="col-span-2">Audience</div>
          <div className="col-span-2">Recipients</div>
          <div className="col-span-2">Sent at</div>
          <div className="col-span-1 text-right">Actions</div>
        </div>
        {!loaded && <div className="px-5 py-6 font-mono-tech text-white/40 text-sm">/ loading...</div>}
        {loaded && list.length === 0 && (
          <div className="px-5 py-10 text-center">
            <div className="font-mono-tech text-white/50 text-sm">/ no broadcasts yet.</div>
            <Link to="/admin/broadcasts/new" className="btn-ghost-neon mt-4 inline-flex">Send your first broadcast →</Link>
          </div>
        )}
        {list.map((b) => (
          <Link key={b.id} to={`/admin/broadcasts/${b.id}`} className="grid grid-cols-12 gap-2 px-5 py-4 border-b border-cyber-line items-center hover:bg-cyber-elevated transition-colors" data-testid={`broadcast-row-${b.id}`}>
            <div className="col-span-1 text-white">
              {b.channel === "email" ? <EnvelopeSimple size={18} weight="bold" /> : <ChatCircle size={18} weight="bold" />}
            </div>
            <div className="col-span-4">
              <div className="text-white truncate">{b.name}</div>
              <div className="font-mono-tech text-xs text-white/50 truncate">{b.subject || (b.body_text || "").slice(0, 80)}</div>
            </div>
            <div className="col-span-2 font-mono-tech text-xs text-cyber-yellow uppercase tracking-[0.15em]">{AUDIENCE_LABEL[b.audience] || b.audience}</div>
            <div className="col-span-2 font-mono-tech text-xs">
              <span className="text-white">{b.recipient_count}</span>
              {b.stubbed_count > 0 && <span className="text-cyber-yellow ml-2" title="Stubbed (no provider key)">{b.stubbed_count} stub</span>}
              {b.sent_count > 0 && <span className="text-cyber-green ml-2">{b.sent_count} sent</span>}
              {b.failed_count > 0 && <span className="text-cyber-red ml-2">{b.failed_count} failed</span>}
            </div>
            <div className="col-span-2 font-mono-tech text-xs text-white/50">{b.sent_at ? new Date(b.sent_at).toLocaleString() : "—"}</div>
            <div className="col-span-1 flex justify-end">
              <button
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); remove(b.id); }}
                className="text-cyber-red hover:text-white"
                data-testid={`delete-${b.id}`}
                aria-label="Delete"
              ><Trash size={14} /></button>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminBroadcasts;
